export const DEFAULT_CURRENCY_CODE_ASW = 'JPY';

/**
 * オフィスコード
 * */
/** Bizオフィスコード(ADO) */
export const ANA_BIZ_OFFICE_CODE = 'SPKHD08BZ';
/** 有償ADOオフィスコード */
export const JAPANESE_REVENUE_OFFICE_CODE = 'SPKHD08DD';
/** APFオフィスコード */
export const APF_OFFICE_CODE = 'SPKHD08AP';
/** ADOオフィスコード */
export const OFFICE_CODE_JP = 'SPKHD08';
